import { AGENT_TYPE } from "../../interfaces/db"
import { SummarizerResult } from "interfaces/ai-automations"
import { RequestState } from "interfaces/ai-automations"

export type AGENT_DATA = {
    status: RequestState,
    url: string | null,
    has_data: boolean
    info?: null | SummarizerResult
    scraped_data?: string | null
    error_reason?: string | null
}

export const jsonSafeToAgentData = (data: any): AGENT_DATA => { return {status: data.status, url: data.url, has_data: data.has_data, info: data.info, scraped_data: data.scraped_data } }

export type ProspectData = {
    prospect_name: string | null
    prospect_company: string | null
    prospect_title: string | null
    agent_data: {[k in AGENT_TYPE]: AGENT_DATA}
    numbers: string[]
}
